import { oppgaveFrontendProject } from "../types/project-name-constants";
import type { HNOppgaveFrontend } from "../types/Resources";

import { useResources } from "../resources/index";

export const useGetResources = (
  projectName: string = oppgaveFrontendProject,
): HNOppgaveFrontend | undefined => {
  const resources = useResources<HNOppgaveFrontend>(projectName);
  return resources ?? undefined;
};
